import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_API_KEY);

// Use to encapsulate
export const StripeScope = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
